import { SbbToggleCheck } from "@sbb-esta/lyne-react/toggle-check";
import { FormField } from "components/Forms/FormField";
import { useTranslations } from "providers";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

import { HookFormError } from "./HookFormError";
import { HookFormField } from "./HookFormField";

interface HookFormToggleProps<TFieldValues extends FieldValues, TName extends Path<TFieldValues>> extends FormField {
  name: TName;
  control: Control<TFieldValues, unknown, TFieldValues>;
  labelYes?: string;
  labelNo?: string;
}

export const HookFormToggle = <TFieldValues extends FieldValues, TName extends Path<TFieldValues>>(
  props: HookFormToggleProps<TFieldValues, TName>
) => {
  const { name, control, labelNo, labelYes, required, label, contextHelp } = props;
  const i18n = useTranslations();

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required }}
      render={({ field, fieldState }) => {
        const { error } = fieldState;
        const { ref, disabled, value, onChange, onBlur } = field;
        return (
          <HookFormField name={name} label={label} required={required} contextHelp={contextHelp}>
            <SbbToggleCheck
              ref={ref}
              disabled={disabled}
              checked={value}
              onChange={(e) => onChange(e)}
              onBlurCapture={() => onBlur()}
              labelPosition="after"
            >
              {value ? labelYes || i18n.Yes : labelNo || i18n.No}
            </SbbToggleCheck>
            <HookFormError error={error} />
          </HookFormField>
        );
      }}
    />
  );
};
